module.exports = __webpack_public_path__ + "static/media/desktop.88eaab27.jpg";